import {ActivatedRoute} from '@angular/router';
import {IBreadcrumb} from '@shared/interfaces';
import {getNested} from '@shared/helpers/helpers';

export const buildBreadCrumb = (route: ActivatedRoute, metadata?: any): IBreadcrumb => {
  const snapshot = route.snapshot;
  let label = '';
  let navTo = '/';

  if (snapshot && snapshot.data) {
    label = snapshot.data.title;
    if (snapshot.data.type === 'report') {
      if (getNested(metadata, 'informationLevel') === 'full') {
        navTo = snapshot.data.navToFullReport;
      } else {
        navTo = snapshot.data.navToQuickReport;
      }
    } else {
      navTo = snapshot.data.navTo;
    }
  }

  let nextUrl;
  // Navigate back to a report
  if (navTo === '/r/' || navTo === '/q/') {
    const reportId = snapshot.queryParams.reportId;
    nextUrl = navTo + reportId;
  } else {
    nextUrl = navTo;
  }
  if (route.firstChild) {
    return buildBreadCrumb(route.firstChild, metadata);
  }
  if (!label || !nextUrl) {
    return;
  }
  return {
    label, url: nextUrl
  } as IBreadcrumb;
};
